
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1159:157)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#fff"}}),_c('path',{attrs:{"d":"M33 21.636V24h-3v-2.364h3zM33 13v6.273h-3V13h3z","fill":"#FF5D15"}})]),_c('path',{attrs:{"d":"M26 23.889v5.555a.536.536 0 01-.176.393.625.625 0 01-.424.163H14.6a.625.625 0 01-.424-.163.536.536 0 01-.176-.393V23.89h12zm0-1.111H14v-2.222c0-.148.063-.29.176-.393A.625.625 0 0114.6 20h10.8c.16 0 .312.058.424.163a.536.536 0 01.176.393v2.222zm-4.2 4.444v1.111h2.4v-1.11h-2.4z","fill":"#FF5D15"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1159:157","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1159:157"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1159:157","result":"shape"}})])])])
          )
        }
      }
    